// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ENumberFormatPolicy, formatNumber, parseEntityPresentation, resolveNumberFormatPolicy, } from "@sequentech/ui-core";
var NUMBER_FORMAT_SAMPLE = 1234567.89;
var sample = function (policy) { return formatNumber(NUMBER_FORMAT_SAMPLE, policy, 2); };
/** The policy an event's presentation names, if it is one this version doesn't know. */
var getUnknownNumberFormatPolicy = function (presentation) {
    var _a;
    var policy = (_a = parseEntityPresentation(presentation)) === null || _a === void 0 ? void 0 : _a.number_format_policy;
    if (typeof policy !== "string" || policy === "") {
        return undefined;
    }
    return resolveNumberFormatPolicy(policy) === policy ? undefined : policy;
};
/**
 * One choice per policy, labelled like macOS's Number format menu: with a
 * sample. A policy the event names that this version doesn't know, such as a
 * newer version's, is listed too, so the event keeps it until another one is
 * chosen. Its label says it is shown as the default.
 */
export var getNumberFormatPolicyChoices = function (presentation, t) {
    var choices = Object.values(ENumberFormatPolicy).map(function (policy) { return ({ id: policy, name: sample(policy) }); });
    var unknown = getUnknownNumberFormatPolicy(presentation);
    return unknown === undefined
        ? choices
        : __spreadArray(__spreadArray([], choices, true), [
            {
                id: unknown,
                name: t("electionEventScreen.field.numberFormatPolicy.unknownPolicy", {
                    policy: unknown,
                    sample: sample(unknown),
                }),
            },
        ], false);
};
/**
 * The policy an election event writes its numbers with. Events whose
 * presentation names none, or one this version does not know, use the default.
 */
export var getElectionEventNumberFormatPolicy = function (presentation) {
    var _a;
    return resolveNumberFormatPolicy((_a = parseEntityPresentation(presentation)) === null || _a === void 0 ? void 0 : _a.number_format_policy);
};
